import React, { useState } from 'react';
import { Badge, Dropdown, InputGroupProps } from "react-bootstrap";
import { FieldCondition, MenuItemCategory, MenuItemType, NavObjectType } from "../Components/navigationTypes";
import { RPWDataReader, getDataReader } from '../livedataFuncs'
import "./menuItem.css"
import { IndicatorBadgeType } from "./sideTypes";
import { runInnerFunction } from "../compatManager";
import ListGroup from 'react-bootstrap/ListGroup';
import { useAppSelector } from "../redux/hooks";
import { useDispatch } from 'react-redux';
import { lddStateObject, setLawyerListState } from '../redux/reducer';

interface IProps {
    nav: (obj: NavObjectType) => void;
    menuType?: MenuItemCategory,
    buyer?: Record<string, string>,
    title?: boolean,
    agreement?: boolean,
    final?: boolean,
    numOfTabs?: number,
    label: string,
    indicatorList?: Array<IndicatorBadgeType>,
    warn?: boolean,
    children?: any,
    link: NavObjectType,
    subIndex?: string,
    dropdownOptions?: Array<MenuItemType>,
    requiredFields?: FieldCondition[],
    symbol?: "copyright" | "trademark" | "registered",
    page?: NavObjectType,
}

const labelPairs = {
    "Client Intake Information": "addIntakeFields",
    "Document Exchange": "documentsRequested",
    "Client Retainer": "retainerAgreement",
    "Identity Verification": "clientConnectId",
    "Source of Funds": "sourceOfFunds",
    "Manage Session": "remoteClosingCalls",
}

export const MenuItem = (props: IProps) => {
    const dispatch = useDispatch();
    const label = props.label;
    const [showCollapseMenu, setShowCollapseMenu] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);

    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const DataReaderObj: RPWDataReader = getDataReader(livedataRootContainer.dataRoot);
    const dashFields = DataReaderObj.getDashboardFields();

    const handleAddIntakeInformation = async () => {
        try {
            DataReaderObj.updateIntakeInformation(labelPairs[label], true);
            setForceUpdate(forceUpdate + 1);
        } catch (e) {
            alert(`Error in updating intake field value: ${e.message || e}`)
        }
    };

    return (
        <>
            <ListGroup.Item
                action
                eventKey={`${props.link?.controller?.tabName}-${props.link?.controller?.tabNumber}-${props.link?.actionParam}-${label}`}
                active={(props.page && props.page.label === label) || (props.page && props.page.reactFrame === 'builderesign' && label.includes('e-signing') && !props.page.label.includes('Documents for eSigning'))}>
                <div style={{ display: "flex", width:'100%', alignItems:'center' }} onClick={() => {
                    if (labelPairs.hasOwnProperty(label)) {
                        handleAddIntakeInformation();
                    }
                    if (props.menuType === MenuItemCategory.WindowOpen &&
                        (props.link.component === "" && typeof props.link.url === "string")) {
                        window.open(props.link.url);
                    } else if (props.link) props.nav({ label: label, ...props.link });
                    if (label === "+ Lawyer") {
                        dispatch(setLawyerListState(true));
                    }
                    if (props.menuType === MenuItemCategory.Dropdown) {
                        setShowCollapseMenu(!showCollapseMenu);
                    }
                }}>
                    <MenuItemRow def={props} label={label} extra={MenuItemExtras(props, showCollapseMenu, setShowCollapseMenu)} symbol={props.symbol} dashFields={dashFields}/>
                </div>
                {props.children}
            </ListGroup.Item>
            
            {props.menuType === MenuItemCategory.Dropdown && showCollapseMenu &&
                <ListGroup className="sub-menu">
                    {props.dropdownOptions.map((option, mapindex) => {
                        return (
                            <ListGroup.Item action key={`${option.label}-${mapindex}`}
                                onClick={() => { if (typeof option.navigate.url === "string") window.open(option.navigate.url) }}>
                                <span>{option.label}</span>
                                <i className="fa-regular fa-arrow-up-right"></i>
                            </ListGroup.Item >
                        )
                    })}
                </ListGroup>
            }
        </>

    );
}

const MenuItemExtras = (props: IProps, showCollapseMenu: boolean, setShowCollapseMenu: React.Dispatch<React.SetStateAction<boolean>>) => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const processor: RPWDataReader = getDataReader(livedataRootContainer?.dataRoot);

    switch (props.menuType) {
        case MenuItemCategory.Person:
            return (
                <span className="hover-options">
                    {((props.link.controller.tabName === "TransfereeDetails" && processor.getPSM() !== "S") || (props.link.controller.tabName === "TransferorDetails" && processor.getPSM() === "S")) &&
                        <i onClick={(e) => { e.stopPropagation(); props.nav({ ...props.link, scrollToId: processor.getPSM() === "S" ? "ReactCompatShellPopupHeaderSale" : "ReactCompatShellPopupHeader" }) }} className="fa-solid fa-id-card menuHoverItem"></i>
                    }
                    <span className="options">{MoveUpDown(props, processor)}</span>
                </span>
            )
        case MenuItemCategory.Property:
            return (
                <span className="hover-options">
                    {props.label === 'Extra Properties' && (
                        <Badge bg="warning" text="dark" pill>{processor.getExtraPropertyNodesLength()}</Badge>
                    )}
                </span>
            );
        case MenuItemCategory.LawyerList:
            return (
                <>
                    <Badge bg="info" text="dark" className="hasOptionsBadge" pill>{processor.getOtherSideLawyerBadge()}</Badge>
                    <span className="hover-options">
                        <span className="options">{ChangeLawyer()}</span>
                    </span>
                </>
            )
        case MenuItemCategory.AdditionalParties:
            return (
                props.indicatorList.map((badge) => (
                    <React.Fragment key={badge.label + props.label + props.subIndex}>
                        <Badge bg="system" text="dark" className="hasOptionsBadge" pill>{badge.label}</Badge>
                        <span className="hover-options" key={badge.label + props.label + props.subIndex}>
                            <span className="options">{ChangeAdditionalParty(props, badge.label)}</span>
                        </span>
                    </React.Fragment>
                ))
            );
        case MenuItemCategory.Dropdown:
            return (
                <span className="hover-options">
                    {showCollapseMenu ?
                        <i className="fa-solid fa-caret-up" onClick={() => setShowCollapseMenu(!showCollapseMenu)}></i> :
                        <i className="fa-solid fa-caret-down" onClick={() => setShowCollapseMenu(!showCollapseMenu)}></i>
                    }
                </span>
            )
        case MenuItemCategory.WindowOpen:
            return (
                <i className="fa-regular fa-arrow-up-right"></i>
            )
        default:
            return (
                props.indicatorList.map((badge) => {
                    const label = badge.label;
                    const hasOptions = (label === "VTB" || label === "New");
                    return (
                        <React.Fragment key={badge.label + props.label + props.subIndex}>
                            <Badge pill text="dark" bg="custom" className={hasOptions ? "hasOptionsBadge" : ""}>{label}</Badge>
                            <span key={badge.label + props.label + props.subIndex} className={badge.category === "Mortgage" ? "hover-options" : ""}>
                                {hasOptions && <span className="options">{MoveUpDown(props, processor)}</span>}
                            </span>
                        </React.Fragment>
                    )
                })
            )
    }
}

const MenuItemRow = (props: {
    def: any,
    label: string,
    extra?: any,
    symbol: "copyright" | "trademark" | "registered",
    dashFields: any
}) => {

    const indicatorShowCondition = (
        props.label === "+ Lawyer"
        || props.label === "+ Title Insurance"
        || props.label === "+ Lender"
    );

    const missingInfoCondition = ( 
        props.label === "+ Lender"
    );

    let showPlusIcon = false;

    if (props.dashFields) {
        showPlusIcon = labelPairs[props.label] && props.dashFields[labelPairs[props.label]] === "false";
    }

    return (
        <>
            <i className={`indicator indicator-warn ${indicatorShowCondition ? "show" : ""}`} />
            <span className={`item-name ${missingInfoCondition || showPlusIcon || indicatorShowCondition === true ? "missing-info" : ""}`}>
                {showPlusIcon && '+ '}
                {props.label}
                {props.label === "Soluno Export" && <Badge className="indicator-new-inline" >New</Badge>}
            </span>

            {props.symbol &&
                <span className={`item-name item-symbol`}>
                    {props.symbol === "copyright" ? <>&#169;</> :
                        props.symbol === "registered" ? <>&#174;</> :
                            props.symbol === "trademark" ? <>&#8482;</> :
                                null}
                </span>
            }
            {props.extra}
        </>
    )
}

function ChangeLawyer() {
    const dispatch = useDispatch();
    return (
        <Dropdown drop='end'>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu>
                <Dropdown.Header>Options</Dropdown.Header>
                <Dropdown.Item onClick={() => {
                    runInnerFunction('ReactShell.reactDeleteSolicitor', null);
                }}>
                    Remove
                </Dropdown.Item>
                <Dropdown.Item onClick={
                    () => {
                        dispatch(setLawyerListState(true));
                    }
                }>
                    Change
                </Dropdown.Item>
                <Dropdown.Item onClick={() => {
                    runInnerFunction('ReactShell.ReactExportInfoToRepository', "Solicitor");
                }}>
                    Update Database
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

function ChangeAdditionalParty(props: IProps, label: string) {
    const type = props.link.controller.tabName.toString();
    let nodeName = "";
    switch (label) {
        case "Referral":
        case "Water Company":
            nodeName = label;
            break;
        case "Relocation Co.":
            nodeName = "Relocation Company";
            break;
        default:
            nodeName = type;
    }

    return (
        <Dropdown drop='end'>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu>
            <Dropdown.Header>Options</Dropdown.Header>
                <Dropdown.Item
                    onClick={() => {
                        runInnerFunction('ReactShell.reactDeleteAdditiontalParty', nodeName);
                    }}>
                    Remove
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

function MoveUpDown(props: IProps, processor: RPWDataReader) {
    return (
        <Dropdown drop='end'>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu>
            <Dropdown.Header>Options</Dropdown.Header>
                <Dropdown.Item
                    onClick={(e) => {
                        if (props.link.controller.tabNumber !== 1) {
                            const type = props.link.controller.tabName
                            const index = Number(props.link.controller.tabNumber) - 1
                            processor.moveNodeUp(type, index);
                            switch (type) {
                                case "Mortgages":
                                    break;
                                case "TransferorDetails":
                                case "TransfereeDetails":
                                default:
                                    props.nav({ ...props.link, controller: { tabName: type, tabNumber: index } })
                                    break;
                            }
                        }
                        e.stopPropagation();
                    }}
                    disabled={props.link.controller.tabNumber === 1}>Move Up</Dropdown.Item>
                <Dropdown.Item
                    onClick={(e) => {
                        if (props.link.controller.tabNumber !== props.numOfTabs) {
                            const type = props.link.controller.tabName
                            const index = Number(props.link.controller.tabNumber) - 1
                            processor.moveNodeDown(type, index);
                            switch (type) {
                                case "Mortgages":
                                    break;
                                case "TransferorDetails":
                                case "TransfereeDetails":
                                default:
                                    props.nav({ ...props.link, controller: { tabName: type, tabNumber: index + 2 } })
                                    break;
                            }
                        }
                        e.stopPropagation();
                    }}
                    disabled={props.final || props.link.controller.tabNumber === props.numOfTabs}>Move Down</Dropdown.Item>
                <Dropdown.Item
                    onClick={(e) => {
                        const type = props.link.controller.tabName
                        const index = Number(props.link.controller.tabNumber) - 1
                        processor.deleteNode(type, index);
                        e.stopPropagation();
                        if (Number(props.link.controller.tabNumber) > 1) {
                            const navobj = props.link;
                            navobj.controller.tabNumber--;
                            props.nav(navobj);
                        }
                    }}>Remove</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

const CustomToggle = React.forwardRef<HTMLInputElement, InputGroupProps>(
    ({ children, onClick }, ref) => (
        <i className={"fa-solid fa-ellipsis-vertical"}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}>
            {children}
        </i>
    ))
